import { render, staticRenderFns } from "./project-list-table.vue?vue&type=template&id=27521ad0&"
import script from "./project-list-table.vue?vue&type=script&lang=js&"
export * from "./project-list-table.vue?vue&type=script&lang=js&"
import style0 from "./project-list-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./project-list-table.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports